'use strict';

var sentry = require('./sentry-config');
var segment = require('./segment-config');
var sitewit = require('./sitewit-config');

module.exports = {
  sentry: sentry,
  segment: segment,
  sitewit: sitewit
};
